import { IconCategory, IconFiles, IconFolders, IconPrompt, IconTag, IconUsers } from "@tabler/icons-react";
import { routes } from "@/configs/router.config/routes";
import { NavigationConfigArray } from "../@types/navigation";

// IconはTabler Iconsのコンポーネントを使用
// https://tabler.io/icons

const navConfig = (
  currentWorkspaceId: string,
  isSuperAdmin: boolean,
): NavigationConfigArray => {
  const links = [
    {
      label: "カテゴリ管理",
      icon: IconCategory,
      initiallyOpened: true,
      links: [
        { label: "カテゴリ登録", link: routes.categoryUpload(currentWorkspaceId) },
        { label: "ダウンロード", link: routes.categoryDownload(currentWorkspaceId) },
        { label: "表示グループ管理", link: routes.displayGroup(currentWorkspaceId) },
      ],
    },
    {
      label: "VoCデータ管理",
      icon: IconFiles,
      initiallyOpened: true,
      links: [
        { label: "VoCアップロード", link: routes.vocUpload(currentWorkspaceId) },
        { label: "VoCアップロード履歴", link: routes.vocUploadHistory(currentWorkspaceId) },
        { label: "VoC属性管理", link: routes.attributeManagement(currentWorkspaceId) },
        { label: "分析", link: routes.execAnalysis(currentWorkspaceId) },
      ],
    },
    {
      label: "ユーザー管理",
      icon: IconUsers,
      initiallyOpened: true,
      links: [{ label: "ユーザー一覧", link: routes.userList(currentWorkspaceId) }],
    },
    {
      label: "タグ管理",
      icon: IconTag,
      initiallyOpened: true,
      links: [
        { label: "タグ一覧", link: routes.tagList(currentWorkspaceId) },
        { label: "タグ割当", link: routes.tagAssignment(currentWorkspaceId) },
      ],
    },
  ];

  if (isSuperAdmin) {
    return links.toSpliced(4, 0, {
      label: "プロンプト管理",
      icon: IconPrompt,
      initiallyOpened: true,
      links: [{ label: "プロンプト編集", link: routes.promptEdit(currentWorkspaceId) }],
    })
      .toSpliced(5, 0, {
        label: "ワークスペース管理",
        icon: IconFolders,
        initiallyOpened: true,
        links: [
          { label: "ワークスペース一覧", link: routes.workspaceList },
        ],
      });
  }

  return links;
};

export default navConfig;
